'use client';

import { InterviewModality } from '@/types/pulse';
import { conversationDuration } from '@/utils/pulse/interview';
import { FileTextIcon } from 'lucide-react';
import { Conversation } from '@/types/pulsedb';
import { useRouter } from 'next/navigation';
import { cn } from '@/utils/cn';

function TextThumbnail({
  conversation,
  interviewSlug
}: {
  conversation: Conversation;
  interviewSlug?: string;
}) {
  const duration = conversationDuration(conversation);
  const router = useRouter();

  return (
    <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
      <div
        className={cn(
          'absolute inset-0 flex flex-col items-center justify-center gap-2 rounded-lg bg-muted',
          'hover:bg-zinc-200 cursor-pointer'
        )}
        onClick={() => {
          if (interviewSlug)
            router.push(
              `/account/interview/${interviewSlug}/conversation?cid=${conversation.interview_conversation_id}`
            );
        }}
      >
        <FileTextIcon className="size-6 text-zinc-400" />
        <span className="text-xs text-zinc-400">Text Conversation</span>

        {duration && (
          <div className="absolute bottom-2 right-2 rounded bg-black px-2.5 py-1 text-xs text-zinc-100">
            {duration}
          </div>
        )}
      </div>
    </div>
  );
}

/**
 * Renders a static thumbnail card for non-video modalities.
 * Add new modality cases here as text/audio/etc grow.
 */
export function ConversationModalityThumbnail({
  conversation,
  interviewSlug
}: {
  conversation: Conversation;
  interviewSlug?: string;
}) {
  if (conversation.modality === InterviewModality.TEXT) {
    return (
      <TextThumbnail
        conversation={conversation}
        interviewSlug={interviewSlug}
      />
    );
  }

  return null;
}
